module.exports = __webpack_public_path__ + "img/integra-beneficios.4fcf2917.svg";